var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Management-Guide-main",class:{ 'Management-Guide-main-mobile': _vm.isMobile}},[_c('Base-title',{attrs:{"title":"产品隐私管理指南"}}),_c('Product-privacy'),_c('Management-guide-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }